import type { ReactNode } from "react";
import { MockupNotice } from "../shell/MockupNotice";

export interface PageHeadProps {
  eyebrow?: ReactNode;
  title: ReactNode;
  sub?: ReactNode;
  cta?: ReactNode;
  /** Flags pending controls on an otherwise-live page. `true` renders a bare
   *  "Coming soon" badge under the title; a string also names what's live vs
   *  pending in plain language with the owing story id (e.g. "The log is live.
   *  Export CSV (coming soon, S-243) isn't wired yet"). See <MockupNotice>. */
  mockup?: boolean | string;
}

export function PageHead({
  eyebrow,
  title,
  sub,
  cta,
  mockup,
}: PageHeadProps): JSX.Element {
  return (
    <div className="page__head">
      <div>
        {eyebrow !== undefined && (
          <div className="page__head__eyebrow">{eyebrow}</div>
        )}
        <h1>{title}</h1>
        {mockup !== undefined && mockup !== false && (
          <MockupNotice
            detail={typeof mockup === "string" ? mockup : undefined}
          />
        )}
        {sub !== undefined && <div className="page__head__sub">{sub}</div>}
      </div>
      {cta !== undefined && <div className="page__head__cta">{cta}</div>}
    </div>
  );
}
